"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCConfigRecommendedValuesT = exports.VRCConfigRecommendedValues = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const vrcavatar_measurement_type_js_1 = require("../../solarxr-protocol/rpc/vrcavatar-measurement-type.js");
const vrctracker_model_js_1 = require("../../solarxr-protocol/rpc/vrctracker-model.js");
class VRCConfigRecommendedValues {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVRCConfigRecommendedValues(bb, obj) {
        return (obj || new VRCConfigRecommendedValues()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVRCConfigRecommendedValues(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new VRCConfigRecommendedValues()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    legacyMode() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    shoulderTrackingDisabled() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    userHeight() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    calibrationRange() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    calibrationVisuals() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    trackerModel() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : vrctracker_model_js_1.VRCTrackerModel.UNKNOWN;
    }
    spineMode(index) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    spineModeLength() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    spineModeArray() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    avatarMeasurementType() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : vrcavatar_measurement_type_js_1.VRCAvatarMeasurementType.UNKNOWN;
    }
    shoulderWidthCompensation() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startVRCConfigRecommendedValues(builder) {
        builder.startObject(9);
    }
    static addLegacyMode(builder, legacyMode) {
        builder.addFieldInt8(0, +legacyMode, +false);
    }
    static addShoulderTrackingDisabled(builder, shoulderTrackingDisabled) {
        builder.addFieldInt8(1, +shoulderTrackingDisabled, +false);
    }
    static addUserHeight(builder, userHeight) {
        builder.addFieldFloat32(2, userHeight, 0.0);
    }
    static addCalibrationRange(builder, calibrationRange) {
        builder.addFieldFloat32(3, calibrationRange, 0.0);
    }
    static addCalibrationVisuals(builder, calibrationVisuals) {
        builder.addFieldInt8(4, +calibrationVisuals, +false);
    }
    static addTrackerModel(builder, trackerModel) {
        builder.addFieldInt8(5, trackerModel, vrctracker_model_js_1.VRCTrackerModel.UNKNOWN);
    }
    static addSpineMode(builder, spineModeOffset) {
        builder.addFieldOffset(6, spineModeOffset, 0);
    }
    static createSpineModeVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startSpineModeVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addAvatarMeasurementType(builder, avatarMeasurementType) {
        builder.addFieldInt8(7, avatarMeasurementType, vrcavatar_measurement_type_js_1.VRCAvatarMeasurementType.UNKNOWN);
    }
    static addShoulderWidthCompensation(builder, shoulderWidthCompensation) {
        builder.addFieldInt8(8, +shoulderWidthCompensation, +false);
    }
    static endVRCConfigRecommendedValues(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createVRCConfigRecommendedValues(builder, legacyMode, shoulderTrackingDisabled, userHeight, calibrationRange, calibrationVisuals, trackerModel, spineModeOffset, avatarMeasurementType, shoulderWidthCompensation) {
        VRCConfigRecommendedValues.startVRCConfigRecommendedValues(builder);
        VRCConfigRecommendedValues.addLegacyMode(builder, legacyMode);
        VRCConfigRecommendedValues.addShoulderTrackingDisabled(builder, shoulderTrackingDisabled);
        VRCConfigRecommendedValues.addUserHeight(builder, userHeight);
        VRCConfigRecommendedValues.addCalibrationRange(builder, calibrationRange);
        VRCConfigRecommendedValues.addCalibrationVisuals(builder, calibrationVisuals);
        VRCConfigRecommendedValues.addTrackerModel(builder, trackerModel);
        VRCConfigRecommendedValues.addSpineMode(builder, spineModeOffset);
        VRCConfigRecommendedValues.addAvatarMeasurementType(builder, avatarMeasurementType);
        VRCConfigRecommendedValues.addShoulderWidthCompensation(builder, shoulderWidthCompensation);
        return VRCConfigRecommendedValues.endVRCConfigRecommendedValues(builder);
    }
    unpack() {
        return new VRCConfigRecommendedValuesT(this.legacyMode(), this.shoulderTrackingDisabled(), this.userHeight(), this.calibrationRange(), this.calibrationVisuals(), this.trackerModel(), this.bb.createScalarList(this.spineMode.bind(this), this.spineModeLength()), this.avatarMeasurementType(), this.shoulderWidthCompensation());
    }
    unpackTo(_o) {
        _o.legacyMode = this.legacyMode();
        _o.shoulderTrackingDisabled = this.shoulderTrackingDisabled();
        _o.userHeight = this.userHeight();
        _o.calibrationRange = this.calibrationRange();
        _o.calibrationVisuals = this.calibrationVisuals();
        _o.trackerModel = this.trackerModel();
        _o.spineMode = this.bb.createScalarList(this.spineMode.bind(this), this.spineModeLength());
        _o.avatarMeasurementType = this.avatarMeasurementType();
        _o.shoulderWidthCompensation = this.shoulderWidthCompensation();
    }
}
exports.VRCConfigRecommendedValues = VRCConfigRecommendedValues;
class VRCConfigRecommendedValuesT {
    constructor(legacyMode = false, shoulderTrackingDisabled = false, userHeight = 0.0, calibrationRange = 0.0, calibrationVisuals = false, trackerModel = vrctracker_model_js_1.VRCTrackerModel.UNKNOWN, spineMode = [], avatarMeasurementType = vrcavatar_measurement_type_js_1.VRCAvatarMeasurementType.UNKNOWN, shoulderWidthCompensation = false) {
        this.legacyMode = legacyMode;
        this.shoulderTrackingDisabled = shoulderTrackingDisabled;
        this.userHeight = userHeight;
        this.calibrationRange = calibrationRange;
        this.calibrationVisuals = calibrationVisuals;
        this.trackerModel = trackerModel;
        this.spineMode = spineMode;
        this.avatarMeasurementType = avatarMeasurementType;
        this.shoulderWidthCompensation = shoulderWidthCompensation;
    }
    pack(builder) {
        const spineMode = VRCConfigRecommendedValues.createSpineModeVector(builder, this.spineMode);
        return VRCConfigRecommendedValues.createVRCConfigRecommendedValues(builder, this.legacyMode, this.shoulderTrackingDisabled, this.userHeight, this.calibrationRange, this.calibrationVisuals, this.trackerModel, spineMode, this.avatarMeasurementType, this.shoulderWidthCompensation);
    }
}
exports.VRCConfigRecommendedValuesT = VRCConfigRecommendedValuesT;
